







import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import NoDealsStub from './NoDealsStub.vue';
import MyDealsTable from './MyDealsTable.vue';
import { mapGetters } from 'vuex';

interface Data {}

interface Methods {}

interface Computed {
  PPDAndTPDLinks: { [key: string]: string };
}

interface Props {}

export default Vue.extend({
  name: 'MyDeals',
  components: {
    NoDealsStub,
    MyDealsTable,
  },
  data() {
    return {};
  },
  mixins: [iconsMixin],
  computed: {
    ...mapGetters(['PPDAndTPDLinks']),
  },
  methods: {},
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
